/**
 * WMenu — polskie tłumaczenia.
 *
 * Source-of-truth shape — `en.ts` / `de.ts` typowane przez `WMenuTranslations`.
 * Stringi UI chrome (aria-label, empty state). Nazwy pozycji menu pochodzą
 * z backendu (per locale), więc tu są tylko fallbacki / etykiety nawigacji.
 */
import type { DeepString } from "@/lib/i18n";

export const pl = {
  ariaLabelFallback: "Menu",
  empty: "Brak pozycji w menu.",
} as const;

export type WMenuTranslations = DeepString<typeof pl>;
